<script setup>
import { getI18n } from '@/plugins/i18n'
import { useChips } from '@/composables/chips'
import { useRateCard } from '@/composables/rate-card'
import { useArchive } from '@/composables/archive'
import ListItem from '@/components/shared/ListItem.vue'

defineProps({
  group: {
    type: Object,
    required: true,
  },
})

const { t } = getI18n()
const { getServiceStructureTypeChip, getServiceTagChips } = useChips()
const { priceLabel } = useRateCard()
const { archivedChip } = useArchive()

const getLabel = (g) => g.code ? `${g.name} (${g.code})` : g.name

const getCaptionChips = (g) => [
  ...getServiceStructureTypeChip(g.structure_type),
  ...getServiceTagChips(g.tags),
  g.archived ? archivedChip : null,
].filter(Boolean)

const getComponentCountLabel = (g) => {
  const count = g.components?.length || 0
  return count > 0 ? `${count} ${t('common.components').toLowerCase()}` : undefined
}
</script>

<template>
  <list-item
    v-bind="$attrs"
    :avatar="group.avatar_file || group.avatar_url"
    avatar-icon="mdi-select-group"
    :label="getLabel(group)"
    :caption-chips="getCaptionChips(group)"
    :right-label="priceLabel(group, true)"
    :right-caption="getComponentCountLabel(group)"
    :disabled="group.archived"
  >
    <template v-if="$slots.right" #right>
      <slot name="right" />
    </template>
  </list-item>
</template>
